import UserIcon from "../../assets/img/user-icon.svg";
import useTranslator from "../../hooks/useTranslator";
import { useNavigate } from "react-router-dom";
import { useContext, useState } from "react";
import AuthContext from "../../context/auth/AuthContext";
import TenantContext from "../../context/tenant/TenantContext";
import DeleteConfiration from "./DeleteConfiration";
import { getGuarantorStatus, toast } from "../../helper/common";
import { BsThreeDotsVertical } from "react-icons/bs";

const PendingFlaggedGuarantors = ({
  allUsers,
  userData,
  llShowOnly,
  isDropdown,
  setIsDropdown,
}) => {
  const { _t } = useTranslator();
  const navigate = useNavigate();

  const { loadUser } = useContext(AuthContext);
  const { upsertSelectedOnboardingUsers } = useContext(TenantContext);
  const [showDeleteConfirmationPrompt, setShowDeleteConfirmationPrompt] =
    useState(false);
  const [deleteGuarantorLoading, setDeleteGuarantorLoading] = useState(false);

  const handleCompleteOnboarding = () => {
    navigate(`/guarantor/onboarding?guarantorName=${userData?.name}`);
  };

  const deleteGuarantor = async () => {
    try {
      setDeleteGuarantorLoading(true);
      const updatedUsers = Array.isArray(allUsers)
        ? allUsers.filter(
            (user) => user.type === "guarantor" && user?.name !== userData?.name
          )
        : [];
      const userid = localStorage.getItem("saveduserid");
      const payload = {
        tenant_id: userid,
        users: updatedUsers,
      };
      await upsertSelectedOnboardingUsers(payload);
      loadUser("tenant");
      setShowDeleteConfirmationPrompt(false);
    } catch (err) {
      toast.error(_t("failedToDeleteGuarantor"));
    } finally {
      setDeleteGuarantorLoading(false);
    }
  };

  return (
    <>
      <div
        className={`earner-card pending-guarantor-card ${
          llShowOnly ? "custom-mb-2" : ""
        }`}
        onClick={() => setIsDropdown(false)}
      >
        <div className="earner-info guarantor-info align-items-center justify-content-between gap-2 d-flex">
          <div className="align-items-center gap-2 d-flex">
            <div className="earner-thumbnail-wrapper">
              <img src={UserIcon} alt="User Icon" />
            </div>
            <h4 className="earner-name">{`${userData?.name ?? ""}`}</h4>
          </div>
          <div
            className="cursor-pointer"
            onClick={(e) => {
              e.stopPropagation();
              setIsDropdown(!isDropdown);
            }}
          >
            {!llShowOnly && <BsThreeDotsVertical className="btnSv" />}
          </div>
        </div>
        <div className="position-relative">
          {isDropdown && !llShowOnly && (
            <div className="editDeleteDropdown">
              <p
                onClick={handleCompleteOnboarding}
                className="custom-gap-2 text-wraping"
              >
                <img src="/images/complete-edit.svg" alt="" />
                {_t("completeAdding")}
              </p>

              <p
                onClick={() => {
                  setIsDropdown(false);
                  setShowDeleteConfirmationPrompt(true);
                }}
                className="deleteText custom-gap-2 text-wraping"
              >
                <img src="/images/delete-icon.svg" alt="" />
                {_t("delete")}
              </p>
            </div>
          )}
        </div>
        {(() => {
          const statusData = getGuarantorStatus(
            "pendingDetails",
            userData?.guarantor_id
          );
          return (
            <div
              style={{
                ...statusData.style,
              }}
              className={`viewMorebtn status-tile viewMorebtn2 ${
                !llShowOnly ? "" : ""
              }`}
            >
              <p style={{ color: statusData.style.color }}>
                {_t(statusData?.status)}
              </p>

              {statusData?.pendingFrom && (
                <p
                  style={{ color: statusData.style.color2 }}
                  className="d-flex align-items-center"
                >
                  <span
                    style={{ backgroundColor: statusData.style.color2 }}
                    className="status-dot"
                  ></span>
                  {_t(statusData?.pendingFrom)}
                </p>
              )}
            </div>
          );
        })()}
      </div>
      <DeleteConfiration
        isOpen={showDeleteConfirmationPrompt}
        onClose={() => setShowDeleteConfirmationPrompt(false)}
        name={`${userData?.name ?? ""}` ?? ""}
        relation={userData?.gurantor_relation ?? ""}
        heading={_t("deleteGuarantor")}
        description={_t("areYouSureDoYouWantToDeleteThisGuarantor")}
        btn1Text={_t("noGoBack")}
        btn2Text={_t("yesDelete")}
        btn1Functionality={() => setShowDeleteConfirmationPrompt(false)}
        btn2Functionality={() => deleteGuarantor()}
        submitLoading={deleteGuarantorLoading}
      />
    </>
  );
};

export default PendingFlaggedGuarantors;
